module.exports = __webpack_public_path__ + "media/img/Landing_Page/self_awareness-04a18e2c94e2ca2f49eb294fa838e3c6.jpg";